import type { MisconceptionDefinition } from './types';

/** REK — Basisrekenen misconcepties. */
export const REK_MISCONCEPTIONS: MisconceptionDefinition[] = [{
  id: 'rek.carry-forgotten',
  label: 'Onthouden vergeten',
  module: 'Basisrekenen',
  description: 'Leerling vergeet de overdracht (carry) bij optellen of vermenigvuldigen.',
  typicalFamilies: ['REK-CIJF-PLUS', 'REK-CIJF-KEER']
}, {
  id: 'rek.borrow-forgotten',
  label: 'Lenen vergeten',
  module: 'Basisrekenen',
  description: 'Leerling vergeet te lenen bij aftrekken, trekt kleinste van grootste af per kolom.',
  typicalFamilies: ['REK-CIJF-MIN']
}, {
  id: 'rek.order-of-operations',
  label: 'Volgorde verkeerd',
  module: 'Basisrekenen',
  description: 'Leerling past de bewerkingsvolgorde (Meneer Van Dansen) niet correct toe.',
  typicalFamilies: ['REK-VOLGORDE']
}, {
  id: 'rek.multiplication-table-error',
  label: 'Tafelfout',
  module: 'Basisrekenen',
  description: 'Leerling kent een specifieke tafel niet uit het hoofd (bijv. 7×8=54).',
  typicalFamilies: ['REK-TAFELS-BASIS', 'REK-TAFELS-UITBREIDEN']
}, {
  id: 'rek.division-remainder-ignored',
  label: 'Rest genegeerd',
  module: 'Basisrekenen',
  description: 'Leerling negeert de rest bij een deling of rondt verkeerd af.',
  typicalFamilies: ['REK-CIJF-DEEL']
}, {
  id: 'rek.subtract-reversed',
  label: 'Aftrekken omgedraaid',
  module: 'Basisrekenen',
  description: 'Leerling trekt het kleinste cijfer van het grootste af per kolom, ongeacht boven/onder.',
  typicalFamilies: ['REK-CIJF-MIN']
}, {
  id: 'rek.negative-written',
  label: 'Negatief getal opgeschreven',
  module: 'Basisrekenen',
  description: 'Leerling schrijft een negatief getal op in plaats van te lenen bij aftrekken.',
  typicalFamilies: ['REK-CIJF-MIN']
}, {
  id: 'rek.column-skipped',
  label: 'Kolom overgeslagen',
  module: 'Basisrekenen',
  description: 'Leerling slaat een kolom over bij cijferend rekenen.',
  typicalFamilies: ['REK-CIJF-MIN', 'REK-CIJF-PLUS']
}, {
  id: 'rek.carry-wrong-value',
  label: 'Verkeerd getal onthouden',
  module: 'Basisrekenen',
  description: 'Leerling onthoudt het verkeerde getal bij de overdracht (bijv. eenheden i.p.v. tientallen).',
  typicalFamilies: ['REK-CIJF-PLUS', 'REK-CIJF-KEER']
}, {
  id: 'rek.left-to-right',
  label: 'Links-naar-rechts zonder voorrang',
  module: 'Basisrekenen',
  description: 'Leerling rekent van links naar rechts zonder de bewerkingsvolgorde toe te passen.',
  typicalFamilies: ['REK-VOLGORDE']
}, {
  id: 'rek.brackets-ignored',
  label: 'Haakjes genegeerd',
  module: 'Basisrekenen',
  description: 'Leerling negeert haakjes en past de standaard voorrangsregels toe.',
  typicalFamilies: ['REK-VOLGORDE']
}, {
  id: 'rek.context-direction-wrong',
  label: 'Verkeerde bewerking bij verhaaltjessom',
  module: 'Basisrekenen',
  description: 'Leerling kiest de verkeerde bewerking (bijv. optellen i.p.v. aftrekken) bij een contextvraag.',
  typicalFamilies: ['REK-CONTEXT-PLUS-MIN', 'REK-CONTEXT-KEER-DEEL']
}, {
  id: 'rek.context-step-forgotten',
  label: 'Stap vergeten bij meerstapsprobleem',
  module: 'Basisrekenen',
  description: 'Leerling berekent slechts een deel van een meerstapsprobleem en vergeet de laatste stap.',
  typicalFamilies: ['REK-CONTEXT-PLUS-MIN', 'REK-CONTEXT-MEERSTAPS']
}, {
  id: 'rek.rounding-wrong-direction',
  label: 'Verkeerd afgerond bij schatten',
  module: 'Basisrekenen',
  description: 'Leerling rondt af naar een niet-dichtstbijzijnd getal bij het schatten.',
  typicalFamilies: ['REK-SCHATTEN']
}, {
  id: 'rek.strategy-wrong-correction',
  label: 'Verkeerde correctie bij compenseren',
  module: 'Basisrekenen',
  description: 'Leerling corrigeert de verkeerde kant op na compenseren (bijv. trekt af i.p.v. optellen).',
  typicalFamilies: ['REK-HANDIG-PLUS-MIN', 'REK-HANDIG-KEER']
}, {
  id: 'rek.partial-calculation',
  label: 'Onvolledige berekening',
  module: 'Basisrekenen',
  description: 'Leerling stopt halverwege de berekening en geeft een tussenresultaat als eindantwoord.',
  typicalFamilies: ['REK-CONTEXT-PLUS-MIN', 'REK-TAFELS-TOEPASSEN']
}, {
  id: 'rek.operation-confused',
  label: 'Bewerkingen verward',
  module: 'Basisrekenen',
  description: 'Leerling verwart bewerkingen (bijv. vermenigvuldigt i.p.v. optellen, of deelt i.p.v. aftrekken).',
  typicalFamilies: ['REK-CONTEXT-KEER-DEEL', 'REK-GEMENGD-BASIS']
}, {
  id: 'rek.strategy-suboptimal',
  label: 'Kiest niet-handige strategie',
  module: 'Basisrekenen',
  description: 'Leerling kiest een strategie die wel werkt maar niet handig is (bijv. cijferend i.p.v. factoren herkennen).',
  typicalFamilies: ['REK-HANDIG-KEER', 'REK-HANDIG-DEEL', 'REK-HANDIG-PLUS-MIN']
}, {
  id: 'rek.calculation-error',
  label: 'Rekenfout',
  module: 'Basisrekenen',
  description: 'Leerling maakt een rekenfout bij vermenigvuldigen, delen of een tussenstap (niet gerelateerd aan een specifieke misconceptie).',
  typicalFamilies: ['REK-CONTEXT-KEER-DEEL', 'REK-HANDIG-KEER', 'REK-HANDIG-DEEL', 'REK-GEMENGD-TOETS']
}, {
  id: 'rek.context-wrong-data',
  label: 'Verkeerde gegevens uit context',
  module: 'Basisrekenen',
  description: 'Lereng schrijft een getal uit de opgave (bijv. het verkeerde tarief) of het verkeerde aantal of de verkeerde deler.',
  typicalFamilies: ['REK-CONTEXT-KEER-DEEL', 'REK-GEMENGD-TOETS']
}];